<!--
 * @Author: Autumn.again
 * @Date: 2023-07-19 09:41:38
 * @LastEditors: Autumn.again
 * @LastEditTime: 2023-07-26 16:52:20
 * @FilePath: \User-Information-System\src\components\CurrentAddress\CurrentAddress.vue
 * Copyright: 2023 by Autumn.again, All Rights Reserved.
-->
<!--
 * @Author: Jacob.Zhang
 * @Description: 现居住地址
-->
<template>
    <el-form ref="ruleForm" :model="value" :rules="formRules" class="current-address">
        <el-form-item prop="country">
            <CountrySelect v-model="value.country" />
        </el-form-item>
        <el-form-item v-if="isMainlandAddressMode && !hideCityPicker" prop="area">
            <CitySelect :country="value.country" v-model="value.area" />
        </el-form-item>
        <!-- 国内地址 -->
        <el-form-item v-if="isDetails && isMainlandAddressMode" prop="details">
            <el-input v-model="value.details" clearable auto-complete="off" maxlength="50" :placeholder="placeholder">
                <template v-if="!hideCityPicker && value.area && value.area.length" slot="prepend">{{ value.area.join('') }}</template>
            </el-input>
        </el-form-item>
        <!-- 国外地址 -->
        <el-form-item v-if="isOverseasAddressMode" prop="foreign">
            <el-input v-model="value.foreign" clearable auto-complete="off" maxlength="50" :placeholder="placeholder" />
        </el-form-item>
        <el-form-item v-if="!hiddenIs_live_oversea && isLiveOversea && isOverseasAddressMode" id="#live_oversea">
            是否居住满一年及以上：
            <el-radio-group v-model="is_live_oversea">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
            </el-radio-group>
            <div v-if="!is_live_oversea && required" id="live_oversea_warning" :class="!is_live_oversea ? 'is-error': ''">
                请选择是否居住满一年及以上
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'CurrentAddress',
    props: {
        hiddenIs_live_oversea: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object,
            default() {
                return {}
            }
        },
        placeholder: {
            type: String,
            default: "请输入"
        },
        is_live_oversea_year: {
            type: Number,
            default: 0
        },
        required: {
            type: Boolean,
            default: true
        },
        isDetails: {
            type: Boolean,
            default: () => true
        },
        isLiveOversea: {
            type: Boolean,
            default: () => true
        },
        /**
         * 为 true 时：仍走内地（省/市+详细地址）逻辑，但不展示省/市选择、不校验 area、详细地址前不加省市区 prepend
         */
        hideCityPicker: {
            type: Boolean,
            default: false
        },
        /**
         * 是否按「中国内地」展示省/市与详细地址（否则走海外 foreign 等逻辑）
         * 签名：(country: string, addressValue: object) => boolean
         * 未传时默认：country 包含「中国」视为内地（与历史行为一致）
         * @example
         * // 港澳台走海外
         * :is-mainland-country="(c) => !!(c && c.includes('中国') && !/香港|澳门|台湾/.test(c))"
         */
        isMainlandCountry: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            checked1: 0
        }
    },
    computed: {
        /** 已选国家且命中「内地」地址交互 */
        isMainlandAddressMode() {
            const country = this.value && this.value.country
            if (!country) return false
            if (typeof this.isMainlandCountry === 'function') {
                try {
                    return !!this.isMainlandCountry(country, this.value)
                } catch (e) {
                    console.warn('[CurrentAddress] isMainlandCountry error:', e)
                }
            }
            return String(country).includes('中国')
        },
        /** 已选国家且走海外地址交互 */
        isOverseasAddressMode() {
            const country = this.value && this.value.country
            if (!country) return false
            return !this.isMainlandAddressMode
        },
        formRules() {
            const rules = {
                country: [{ required: this.required, message: '请选择国家', trigger: 'change' }],
                details: [{ required: this.required, message: '请输入地址', trigger: 'blur' }],
                foreign: [{ required: this.required, message: '请输入地址', trigger: 'blur' }]
            }
            if (this.isMainlandAddressMode && !this.hideCityPicker) {
                rules.area = [{ required: this.required, message: '请选择城市', trigger: 'change' }]
            }
            return rules
        },
        // 海外居住满1年
        is_live_oversea: {
            get () {
                return this.is_live_oversea_year
            },
            set (val) {
                this.$emit('update:is_live_oversea_year', val)
            }
        }
    },
    methods: {
        // async checkInfo() {
        //     try {
        //         await this.$refs.ruleForm.validate()
        //     } catch (error) {
        //         console.log(error)
        //     }
        // },
        // 校验表单
        checkInfo() {
            if (this.required) {
                return new Promise(async(resolve, reject) => {
                    try {
                        await this.$refs.ruleForm.validate()
                        // resolve()
                        if (!this.hiddenIs_live_oversea && this.isOverseasAddressMode) {
                            this.is_live_oversea ? resolve() : reject('error')
                        } else {
                            resolve()
                        }
                    } catch (error) {
                        console.error(error)
                        reject(error)
                    }
                })
            }
        },
        // handleChange(){
        //     if(this.value.country.includes('中国')) this.value.foreign = ''
        //     if(this.value.country && !this.value.country.includes('中国')) this.value.details = ''
        //     this.$emit("input", this.value);
        // }
    }
}
</script>

<style lang="less" scoped>
.current-address {
    display: flex;
    >div:not(:last-of-type) {
        margin-right: 10px;
    }
    .el-select {
        width: 200px;
    }
    >div:nth-of-type(3) {
        flex: 1;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
    #live_oversea {
        position: relative;

        &_warning {
            position: absolute;
            left: 150px;
            bottom: -20px;
            color: red;
            font-size: 12px;
        }
    }
</style>
